'use client'
import React, {useEffect, useState} from 'react'
import { BrandsCopy } from '@/app/copywritting'
import Link from 'next/link'

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  height?: number;
}

const Brands = (props: Props) => {
    const { containerRef } = props;
    const [scrollProgress, setScrollProgress] = useState(0);
    const [scrollColorChange, setScrollColorChange] = useState(false);

    useEffect(() => {
    
        const handleScroll = () => {
          const target = containerRef?.current || document.documentElement;    
          const { scrollTop, scrollHeight, clientHeight } = target;
          const totalHeight = scrollHeight - clientHeight;
          const progress = (scrollTop / totalHeight) * 100;
          if (progress >= 73.5) {
            setScrollColorChange(true)
          } else {
            setScrollColorChange(false)
          }
    
        }
        window.addEventListener("scroll", handleScroll)
        return () => {window.removeEventListener("scroll", handleScroll)}
        }, [])
  return (
    <section>
        
        <div className="flex flex-col justify-center items-center py-10 md:py-20">
            <div className='flex flex-col items-center pb-5'>
                <h3 className="text-4xl md:text-big-heading font-bold pb-6 uppercase text-center tracking-tighter leading-heading">{BrandsCopy.title}</h3>
                  <p className={`w-full md:w-[60%] text-[#6d6e73] text-medium md:text-xl md:text-[#f8f8ff] text-center px-5 leading-none md:leading-subheading transition-colors duration-500 ease-in-out ${scrollColorChange ? "md:text-black" : "md:text-white"}`}>{BrandsCopy.subtitle}</p>
            </div>
            <div className='w-full h-25 md:h-50 md:px-50'>
                <div className='w-full h-12 md:h-25 grid grid-flow-col grid-rows-1 place-items-center'>
                    <div className='grid-item'>
                        <Link href='https://www.ecoguardenergy.com' target='_blank'>
                            <img alt='' className='object-contain filter grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand01.webp'} width={140}></img>
                        </Link>
                    </div>
                    <div className='grid-item'>
                        <Link href='https://www.leuniqueskin.com' target='_blank'>
                            <img alt='' className='object-contain grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand05.webp'} width={140}></img>
                        </Link>
                    </div>
                    <div className='grid-item'>
                        <Link href='https://www.balancelifestylesolutions.com' target='_blank'>
                            <img alt='' className='object-contain grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand03.webp'} width={140}></img>
                        </Link>
                    </div>
                    <div className='grid-item'>
                        <Link href='https://www.aehomeservices.com' target='_blank'>
                            <img alt='' className='object-contain grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand06.webp'} width={140}></img>
                        </Link>
                    </div>
                </div>
                <div className='w-full h-12 md:h-25 grid grid-flow-col grid-rows-1 place-items-center'>
                    <div className='grid-item'>
                        <Link href='https://www.nomadsworlds.com' target='_blank'>
                            <img alt='' className='object-contain grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand02.webp'} width={140}></img>
                        </Link>
                    </div>
                    <div className='grid-item'>
                        <Link href='https://www.coffeematchexperience.com' target='_blank'>
                        <img alt='' className='object-contain grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand04.webp'} width={140}></img>
                        </Link>
                    </div>
                    {/* <div className='grid-item'>
                        <a href='https://www.blindpig.com' target='_blank'>
                            <img className='object-contain grayscale transition delay-50 duration-300 ease-in-out hover:-translate-y-1 hover:scale-120 hover:grayscale-0' src={'/brands_s/shdws-brand07.webp'} width={140}></img>
                        </a>
                    </div> */}
                </div>
            </div>
            
            {/* <button className="font-bold bg-[#0b0d15] md:py-3 md:px-6 rounded-md hover:bg-[#892CDC] text-[#f8f8ff] cursor-pointer tracking-wide">
                  Let's Talk
            </button> */}
      </div>
    </section>
  )
}

export default Brands